<template>
  <transition name="fade">
    <div class="LanguageSelection" v-show="languageSelectionVisible">
      <div class="lc-container">
        <img class="lc-logo" :src="publicPath + '/media/Evonik360/Evonik-Logo.png' " alt="" />
        <div class="lc-title">Bitte wählen Sie eine Sprache aus:</div>
   
        <div class="lc-language" @click="loadTour('de')">
          <img
            class="lc-flag"
            :src="publicPath + '/media/Evonik360/Icons/Flag_of_Germany.png'"
            alt=""
          />
          <span>Deutsch</span>
        </div>
        <div class="lc-language" @click="loadTour('en')">
          <img
            class="lc-flag"
            :src="publicPath + '/media/Evonik360/Icons/Flag_of_UK.png'"
            alt=""
          />
          <span>English&nbsp;</span>
        </div>
        <div class="toggleSubtitle">
        <span>Untertitel  </span>
        <toggle-button :value="false"
               color="#981D83"
               padding-right="10px"
                @change="toggleSubtitle"/>
      </div>
      </div>
      <!--
      <video controls width="325" height="245">
  <source src="/media/Evonik360/Subtitles/2_1_Moritz.mp4" type="video/mp4">
  <source src="/media/Evonik360/Subtitles/1_1_Lukas_audio_EN.mp4" type="audio/mp4">
  <track src="/media/Evonik360/Subtitles/en/2_1_Moritz.vtt" kind="subtitles" srclang="de" label="Deutsch">
  <track src="/media/Evonik360/Subtitles/en/4_1_Ibrahim.vtt" kind="subtitles" srclang="en" label="English">
</video>
-->
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import SubtitlesIcon from "vue-material-design-icons/Subtitles.vue";
import SubtitlesOutlineIcon from "vue-material-design-icons/SubtitlesOutline.vue";
import { ToggleButton } from 'vue-js-toggle-button'

export default {
  components: { SubtitlesIcon, SubtitlesOutlineIcon, ToggleButton},
  data: () => ({
    publicPath: process.env.BASE_URL,
    languageSelectionVisible: false,
  }),
  computed: {
    ...mapGetters([
      "panoramaTourZIPEN",
      "panoramaTourZIP",
      "showLanguageSelection",
      "logoURL",
      "mapURL",
      "withSubtitles"
    ]),
  },

  methods: {
    ...mapMutations(["setChosenLanguage", "setWithSubtitles"]),
    toggleSubtitle(){
      this.setWithSubtitles(!this.withSubtitles)
    },
    loadTour(language) {
        this.$store.commit('setChosenLanguage', language );
        // let defaultMapName = this.mapURL.substring(0, this.mapURL.length -4);
        // let ending = this.mapURL.substring(this.mapURL.length -4, this.mapURL.length);
        //console.log(defaultMapName)
        //console.log(ending)

        // let mapName   =     language == "de" ? defaultMapName + "_de" + ending : defaultMapName + "_en" + ending;
        this.$store.commit('setMapURL', this.mapURL );
      let zip =
        language == "de" ? this.panoramaTourZIP : this.panoramaTourZIPEN;
      this.$store
        .dispatch("loadPanoramaTour", { zip: zip, preview: false })
        .then(() => {
          console.log("Data from CMS is loaded!");
        });
      this.languageSelectionVisible = false;
    
    },
  },
  watch: {
    showLanguageSelection() {
      this.languageSelectionVisible = this.showLanguageSelection;
    },
  },
  mounted() {
    document.getElementsByClassName("lc-container")[0].style.opacity = 1;
  },
};
</script>

<style scoped>
.mcp-subtitle{
  background-color: #981D83;
}
.LanguageSelection {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 101;
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
}
.lc-container {
  opacity: 0;
  transition: 1s opacity ease-in;
  display: flex;
  flex-direction: column;
}
.lc-logo {
  width: 350px;
  height: auto;
}
.lc-title {
  font-weight: bolder;
  font-size: 20px;
  text-align: center;
  margin: 50px;
}
.toggleSubtitle{
  font-size: 18px;
  padding: 10px;
}

.lc-language {
  cursor: pointer;
  border: 2px solid black;
  padding: 10px;
  margin: 10px;
  color: black;
  text-align: center;
  font-size: 18px;
}
.lc-language:hover {
  background: var(--primaryColor);
  border: 2px solid var(--primaryColor);
}
.lc-flag {
  width: 50px;
  height: auto;
  margin-right: 20px;
}
</style>
